import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Context from '../../context/Context'

const Bankgiro = ({ onToggleSpecification }) => {
  const context = useContext(Context)

  return (
    <div className="row mt-2">
      <div className="col-12 text-center">
        <button
          style={context.style.button}
          className="btn btn-primary custom-btn-payment"
          onClick={() => onToggleSpecification(true)}
        >
          Bankgiro
        </button>
      </div>
    </div>
  )
}

Bankgiro.propTypes = {
  onToggleSpecification: PropTypes.func.isRequired
}

export default Bankgiro
